export default "__VITE_ASSET__LUp8Ezj7__"